// TabulatorTable.js
import { useEffect, useRef, forwardRef, useImperativeHandle } from "react";
import { useSelector } from "react-redux";

const TabulatorTable = forwardRef(({ data = [], options = {}, onReady, fullHeight = false }, ref) => {
  const tableRef = useRef(null); // 실제 DOM 참조
  const tabulatorRef = useRef(null); // Tabulator 인스턴스 참조
  const commCode = useSelector((state) => state.user.commCode);

  //const focusedFieldRef = useRef(null);


  const setComboItem = function (column) {
    let codeCol = "SSC_CD";
    let textCol = "SSC_CD_KORN_NM";

    let editParam = {};
    let codeDatas = commCode?.data;

    let codes = codeDatas.filter((item) => item.HCL_CD === column.listCode);
    // 전체
    if (column.listAddAll === undefined || column.listAddAll === null)
      column.listAddAll = false;
    if (column.listAddAll === true) {
      editParam[""] = "선택";
    }
    if (codes) {
      // 데이터 추가
      for (let j = 0, lenj = codes.length; j < lenj; j++) {
        var code = codes[j];
        editParam[code[codeCol]] = code[textCol];
      }
    }

    if(column.addListCode && column.addListCode.length > 0) {
      for (let j = 0, lenj = column.addListCode.length; j < lenj; j++) {
        var code2 = column.addListCode[j];
        editParam[code2["value"]] = code2["label"];
      }
    }

    if (!column.editorParams) {
      column.editorParams = {};
    }
    column.editorParams.values = editParam;

    return column;
  };

  const checkComboData = function (options) {
    let columns = options.columns;
    let column;

    for (let i = 0, len = columns.length; i < len; i++) {
      column = columns[i];
      // multi header
      if (column.columns && Array.isArray(column.columns)) {
        let subcolumns = column.columns;
        for (let j = 0, lenj = subcolumns.length; j < lenj; j++) {
          let subcolumn = subcolumns[j];
          if (subcolumn.editor === "list" && subcolumn.listCode) {
            subcolumn = setComboItem(subcolumn);

            subcolumn.formatter = function (cell) {
              return cell.getValue() ?? "";
            };
          }
        }
      } else {
        // 공통코드 콤보
        // {values:{"male":"Male", "female":"Female", "unknown":"Unknown"}}}
        if (column.editor === "list" && column.listCode) {
          column = setComboItem(column);

          column.formatter = function (cell) {
            return cell.getValue() ?? "";
          };
        }
      }
    }
  };

  const requiredTitleFormatter = function (cell) {
    const def = cell.getColumn().getDefinition();

    if (def.required) {
      return `
        <span class="tabulator-required">
          ${def.title}
          <span class="required-star">*</span>
        </span>
      `;
    }
    return def.title;
  };

  const applyRequiredFormatter = (columns) => {
    columns.forEach((column) => {
      if (column.columns && Array.isArray(column.columns)) {
        applyRequiredFormatter(column.columns);
      } else {
        if (column.required === true) {
          column.titleFormatter = requiredTitleFormatter;
        }
      }
    });
  };  

  /*
  const handleFocusIn = (e) => {
    const cellEl = e.target.closest(".tabulator-cell");
    if (!cellEl) return;

    const table = tabulatorRef.current;
    if (!table) return;

    const cell = table.getCell(cellEl);
    if (!cell) return;

    focusedFieldRef.current = cell.getColumn().getField();
  };  
  */

  const keyHandler = (e) => {
    if (!["ArrowUp", "ArrowDown"].includes(e.key)) return;

    e.preventDefault();
    
    const selected = tabulatorRef.current.getSelectedRows()[0];
    if (!selected) return;

    const nextRow =
      e.key === "ArrowDown"
        ? selected.getNextRow()
        : selected.getPrevRow();

    if (!nextRow) return;

    selected.deselect();
    nextRow.select();

    // -----------------------------
    // 같은 column의 cell로 focus 이동
    // -----------------------------
    /*
    const field = focusedFieldRef.current;
    if (field) {
      const nextCell = nextRow.getCell(field);
      if (nextCell) {
        const el = nextCell.getElement();
        el.setAttribute("tabindex", "0");
        el.focus({ preventScroll: true });
      }
    }
      */

    // 최소 스크롤
    const holder = tabulatorRef.current.rowManager.element;
    const rowEl = nextRow.getElement();

    const rowTop = rowEl.offsetTop;
    const rowBottom = rowTop + rowEl.offsetHeight;

    const viewTop = holder.scrollTop;
    const viewBottom = viewTop + holder.clientHeight;

    if (rowBottom > viewBottom) {
      holder.scrollTop = rowBottom - holder.clientHeight;
    } else if (rowTop < viewTop) {
      holder.scrollTop = rowTop;
    }

    // 포커스 유지
    tabulatorRef.current.element.focus({ preventScroll: true });
  };    

  useEffect(() => {
    if (!window.Tabulator) {
      console.error("Tabulator JS가 로드되지 않았습니다.");
      return;
    }

    options.data = data;
    if(!options.placeholder) options.placeholder = "데이터가 없습니다.";
    if (!options.layout) options.layout = "fitColumns";
    if (
      (options.selectable === undefined || options.selectable === null) &&
      (options.selectableRows === undefined || options.selectableRows === null)
    ) {
      options.selectable = 1;
    }
    options.rowSelected = function (row) {
      // 선택된 행이 보이도록 스크롤 이동
      row.getElement().scrollIntoView({ behavior: "smooth", block: "nearest" });
    };

    // combo data
    checkComboData(options);

    let columns = options.columns;
    columns.forEach((column) => {
      if (column.headerSort !== true) {
        column.headerSortTristate = true;
      }
    });

    applyRequiredFormatter(columns);

    if (tableRef.current && !tabulatorRef.current) {
      tabulatorRef.current = new window.Tabulator(tableRef.current, options);
      const createdTable = tabulatorRef.current;
      //onReady?.(tabulatorRef.current);
      tabulatorRef.current.on("tableBuilt", () => {
          setTimeout(() => {
            if (tabulatorRef.current === createdTable) {
              onReady?.(createdTable);
            }
          }, 100); 
      });      

      
      tabulatorRef.current.on("dataLoaded", () => {
        requestAnimationFrame(() => {
          try{
            const rows = tabulatorRef.current?.getRows();
            if(rows && rows.length > 0) {
              const row = tabulatorRef.current.getRows()[0];
              row && row.select();
            }
          }catch(e){}
        });
      });
      

      const el = tabulatorRef.current.element;
      el.setAttribute("tabindex", "0");     
      el.addEventListener("keydown", keyHandler); 
      //el.addEventListener("focusin", handleFocusIn); 
    }

    return () => {
      if (tabulatorRef.current) {
        //tabulatorRef.current.element.removeEventListener("focusin", handleFocusIn);
        tabulatorRef.current.element.removeEventListener("keydown", keyHandler);
        tabulatorRef.current.destroy();
        tabulatorRef.current = null;
      }
    };
  }, []);

  // 외부에서 Tabulator 인스턴스를 접근할 수 있도록 expose
  useImperativeHandle(ref, () => tabulatorRef.current);

  return (
    <div style={fullHeight ? { height: "100%", overflow: "hidden" } : undefined}>
      <div data-isgrid="Y" ref={tableRef} style={fullHeight ? { height: "100%" } : undefined} />
    </div>
  );
});

export default TabulatorTable;
